<script setup lang="ts">
/** 공용 — 제목 + AML 안내/면책 + Date. (3개 폼 동일) */
import CddDocVarField from './CddDocVarField.vue';
</script>

<template>
  <div>
    <div class="cdd-title">Customer Due Diligence Form <span class="cdd-cn">客户尽职调查表格</span></div>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-sec">Customer Due Diligence</td></tr>
        <tr><td class="cdd-intro">
          <div>Identification and verification of a customer as required under <span class="cdd-cn">根据以下要求进行客户身份识别和核实</span>:</div>
          <div class="bullet">•&nbsp; Section 16 of the Anti-Money Laundering, Anti-Terrorism Financing and Proceeds of Unlawful Activities Act 2001 (AMLA); and</div>
          <div class="cdd-cn">2001年《反洗钱、反恐融资及非法活动收益法》（AMLA）第16条;以及</div>
          <div class="bullet">•&nbsp; Paragraph 14 of the AML/CFT/CPF and TFS for DNFBPs and NBFIs policy document.</div>
          <div class="cdd-cn">反洗钱、反恐融资、反扩散融资及针对DNFBPs和NBFIs的定向金融制裁政策文件第14段.</div>
          <div style="margin-top:6px;font-weight:700">Disclaimer <span class="cdd-cn">免责声明</span>:</div>
          <div class="bullet">•&nbsp; This document is intended for guidance on the implementation of CDD, TFS, CRP and EDD in complying with the AML/CFT/CPF and TFS requirements under the AMLA only. Reporting institutions may develop their own forms or checklists in consideration of the size, nature and complexity of the business operations.</div>
          <div class="cdd-cn">本文件旨在指导CDD、TFS、CRP和EDD在符合AML/CFT/CPF和TFS要求下的实施。申报机构可能会根据业务运营的规模、性质和复杂性，制定自己的表格或检查表。</div>
          <div class="bullet">•&nbsp; This document does not contain exhaustive advice or information relating to the subject matter nor should it be used as substitute for legal advice.</div>
          <div class="cdd-cn">本文件不包含与该主题相关的详尽建议或信息，也不应替代法律咨询。</div>
          <div class="bullet">•&nbsp; In the event that the information on Bank Negara Malaysia's official printed documents or any Acts differ from the information contained within this document, the information on such Act and official documents shall prevail and take precedence.</div>
          <div class="cdd-cn">如马来西亚国家银行官方印制文件或任何法案的信息与本文件所含信息存在差异，则该法案及官方文件的信息应优先考虑。</div>
        </td></tr>
      </tbody>
    </table>
    <div class="cdd-date-row">Date: <CddDocVarField field-key="cdd_date" /></div>
  </div>
</template>
